import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserProfileDTO } from '../models/user-profile.model';
import { Membership } from '../models/membership.model';
import { CreatePatRequest, PatCreatedResponse, PatDTO } from '../models/pat.model';
import { KiMcpSichtbarkeit } from '../models/ki.model';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AccountService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiBaseUrl}/api/v1/users/me`;
  private tokensUrl = `${this.apiUrl}/tokens`;

  getProfile(): Observable<UserProfileDTO> {
    return this.http.get<UserProfileDTO>(this.apiUrl);
  }

  getMemberships(): Observable<Membership[]> {
    return this.http.get<Membership[]>(`${this.apiUrl}/memberships`);
  }

  listTokens(): Observable<PatDTO[]> {
    return this.http.get<PatDTO[]>(this.tokensUrl);
  }

  createToken(request: CreatePatRequest): Observable<PatCreatedResponse> {
    return this.http.post<PatCreatedResponse>(this.tokensUrl, request);
  }

  revokeToken(id: string): Observable<void> {
    return this.http.delete<void>(`${this.tokensUrl}/${id}`);
  }

  getKiMcp(): Observable<KiMcpSichtbarkeit> {
    return this.http.get<KiMcpSichtbarkeit>(`${this.apiUrl}/ki-mcp`);
  }
}
